// Initialize the UMD core before extensions, including when imports are sorted by the formatter.
import 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/solid-gauge';

import Highcharts from 'highcharts';

Highcharts.setOptions({
  palette: {
    colorScheme: 'light',
  },
});

if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
  Highcharts.setOptions({
    chart: { animation: false },
    plotOptions: { series: { animation: false } },
    tooltip: { animation: false },
  });

  // Individual marker/state options can override the global animation defaults.
  Highcharts.wrap(
    Highcharts.SVGElement.prototype,
    'animate',
    function (
      this: Highcharts.SVGElement,
      proceed: Highcharts.SVGElement['animate'],
      ...[params, options, complete]: Parameters<Highcharts.SVGElement['animate']>
    ) {
      return proceed.call(
        this,
        params,
        {
          ...(typeof options === 'object' ? options : {}),
          duration: 0,
          defer: 0,
        },
        complete,
      );
    },
  );
}
